// extracted by mini-css-extract-plugin
export default {"formHeading":"nJ-z","form":"oJ-z","submitBtn":"pJ-z","disabled":"qJ-z","input":"rJ-z","error":"sJ-z","submitMsg":"tJ-z","signIn":"uJ-z"};